<template lang="pug">
div
  section.hero.is-primary
    .hero-body
      .container
        p.title {{ heading }}

  section.section
    .container
      div.tags.has-addons.are-medium(v-if="post")
        span.tag Status
        span.tag.is-capitalized(:class="statusColor") {{ post.status }}

      w-form(:cancel="onCancel" :complete="onCompleted" :onDelete="onDelete" :record="record" :mutation="mutation")
        p.field
          label.label Title
          .control
            w-input(type="text" placeholder="A summary statement" required maxlength="60" v-model="formData.title")
        p.field
          label.label Describe your need
          .control
            w-textarea(placeholder="Detailed description of your need." required v-model="formData.description")
        p.field
          label.label Timeline
          .control
            w-input(type="text" placeholder="When do you need this by?" required maxlength="40" v-model="formData.when")
        p.field
          label.label Other resources
          .control
            w-textarea(placeholder="What other resources have you been to for help?" required v-model="formData.other_providers")
        p.field
          label.label Contact
          .control
            w-input(type="text" placeholder="How would you like to be contacted from people willing to help?" required v-model="formData.contact")
</template>

<script>
import FIND_POST from '@/graphql/posts/edit.gql'
import RECENT_POST from '@/graphql/posts/myMostRecent.gql'
import CLOSE_POST from '@/graphql/posts/close.gql'
import INSERT_POST from '@/graphql/posts/insert.gql'
import UPDATE_POST from '@/graphql/posts/update.gql'

export default {
  data () {
    return {
      post: null,
      recentPost: null,
      formData: {
        user_id: null,
        title: '',
        description: '',
        when: '',
        other_providers: '',
        contact: ''
      }
    }
  },

  computed: {
    postId () {
      return parseInt(this.$route.params.id)
    },
    heading () {
      if (this.post) {
        return this.post.title
      } else {
        return 'Post Your Need'
      }
    },
    mutation () {
      return this.post ? UPDATE_POST : INSERT_POST
    },
    record () {
      const data = this.formData
      if (!data.user_id && this.$auth.user) {
        data.user_id = this.$auth.user.id
      }
      return data
    },
    statusColor () {
      if (this.post.status === 'pending') {
        return 'is-info'
      } else if (this.post.status === 'active') {
        return 'is-success'
      } else if (this.post.status === 'closed') {
        return 'is-dark'
      } else if (this.post.status === 'rejected') {
        return 'is-danger'
      }
      return ''
    }
  },

  apollo: {
    post: {
      fetchPolicy: 'no-cache',
      query: FIND_POST,
      variables () {
        return { id: this.postId }
      },
      skip () {
        return !this.postId
      },
      update (data) {
        const post = data.posts_by_pk
        if (post) {
          Object.keys(this.formData).forEach(attribute => {
            this.formData[attribute] = post[attribute]
          })
          this.formData.id = post.id
        }
        return post
      }
    },
    recentPost: {
      fetchPolicy: 'no-cache',
      query: RECENT_POST,
      variables () {
        return {
          user_id: this.$auth.user.id
        }
      },
      skip () {
        return this.postId || !this.$auth.user
      },
      update (data) {
        const post = data.posts[0]
        if (post && this.formData.contact === '') {
          this.formData.contact = post.contact
        }
        return post
      }
    }
  },

  methods: {
    nextPage (params) {
      if (params) {
        this.$router.push({ name: 'post', params: params })
      } else {
        this.$router.push({ name: 'home' })
      }
    },
    onCancel () {
      const params = this.post && { id: this.post.id }
      this.nextPage(params)
    },
    onCompleted (data) {
      this.nextPage({ id: data.id, status: 'success' })
    },
    async onDelete () {
      await this.$apollo.mutate({
        mutation: CLOSE_POST,
        variables: { id: this.post.id }
      })
      this.nextPage()
    }
  }
}
</script>

<style scoped lang="scss">
.field {
  margin-top: 1em;
}
</style>
